import axios from "axios";
import instanceTokenLess from "../../../axiosTokenLess";
import instance from "../../../axios";
export const API_URL = `${process.env.REACT_APP_API_URL}/html5-categories`;
export const BASE_URL = `${process.env.REACT_APP_API_URL}`;
export function getList(queryParams) {
  return instanceTokenLess.post(`${API_URL}/list`, queryParams)
  .then(res => {
      return res;
  })
};

export function createItem(item) {
  return instanceTokenLess.post(`${API_URL}/create`, item)
  .then(res => {
      return res;
  })
};
export function getCompany(queryParams) {
  return instance
    .post(`${BASE_URL}/v3/dropdown/company/short`, queryParams)
    .then((res) => {
      return res;
    });
}
export function fetchCompanyDropdownList(queryParams) {
  return instance
    .post(`${process.env.REACT_APP_API_URL}/v3/dropdown/company/short`, queryParams)
    .then((res) => {
      return res;
    });
}

export function getItemById(id) {
  const selectedCompany = localStorage.getItem('selectedCompany');
  if (!selectedCompany) {
    return Promise.reject(new Error("No company selected"));
  }
  const payload = {
    id: id,
    company: selectedCompany, 
  };
  return instanceTokenLess.post(`${API_URL}/get/${id}`,payload)
  .then(res => {
      return res;
  })
};


// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result

export function findItem(queryParams) {
  return instanceTokenLess.post(`${API_URL}/find`, { queryParams })
  .then(res => {
      return res;
  })
};

// UPDATE => PUT: update the StaffUser on the server
// export function updateItem(item) {
//   return axios.post(`${API_URL}/update/${item._id}`, item);
// }

export function updateItem(item) {
  return instanceTokenLess.post(`${API_URL}/update/${item._id}`, item)
  .then(res => {
      return res;
  })
};

export function updateStatus(item) {
  return instanceTokenLess.post(`${API_URL}/status/${item._id}`, item)
  .then(res => {
      return res;
  })
};

// UPDATE Status
export function updateItemsStatus(ids, status) {
  return axios.post(`${API_URL}/updateStatusForitems`, {
    ids,
    status
  });
}

// DELETE => delete the StaffUser from the server

export function deleteItem(id) {

  const selectedCompany = localStorage.getItem('selectedCompany');
  if (!selectedCompany) {
    return Promise.reject(new Error("No company selected"));
  }
  const payload = {
    id: id,
    company: selectedCompany, 
  };
  return instanceTokenLess.post(`${API_URL}/delete/${id}`, payload)
 
  .then(res => {
      return res;
  })
};

// DELETE items by ids
export function deleteItems(ids) {
  return axios.post(`${API_URL}/deleteitems`, { ids });
}
 